import { gql } from '@apollo/client';

export default gql`
  mutation updateUi {
    updateUi(input: $uiInput) @client
  }
`;
